var $ = require('jquery');
require('fg-frontend/third/highslide/highslide-full');

hs.graphicsDir = '/img/highslide/';
hs.transitions = ['expand', 'crossfade'];
hs.objectLoadTime = 'before'; // Load iframes 'before' or 'after' expansion.
hs.outlineType = '';
hs.align = 'center';
hs.dimmingOpacity = 0.95;

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = '';
hs.lang.creditsText = '';
hs.lang.creditsTitle = '';
hs.captionEval = 'this.a.title';
hs.captionOverlay = { position  : 'below'};

hs.marginBottom = 110;
hs.marginLeft = 30;
hs.marginRight = 30;
hs.marginTop = 30;

if (window.innerWidth >= 992) {
    hs.marginBottom = 85;
    hs.marginLeft = 85;
    hs.marginRight = 85;
    hs.marginTop = 110;
};


hs.maxWidth = 1920;
hs.maxHeight = 1280;

if (hs.registerOverlay) {
    if (window.innerWidth >= 992) {
        hs.registerOverlay({
            fade: 2,
            hideOnMouseOut: false,
            html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton">Zavřít</a>',
            useOnHtml: true,
            position: 'top right',
            relativeTo: 'viewport'
        });
    } else {
        hs.registerOverlay({
            fade: 2,
            hideOnMouseOut: false,
            html: '<a href="javascript:" onclick="return hs.close(this)" class="closebutton">Zavřít</a>',
            useOnHtml: true,
            position: 'bottom center',
            relativeTo: 'viewport'
        });
    }
}


hs.Expander.prototype.onBeforeExpand = function (sender) {
    //jen pro obrazky
    if (sender.a.className.indexOf("hs-htmlExpand") < 0) {

        // dynamicka navigace mezi fotkami

        var arrowLeft = document.createElement('div');
        var arrowRight = document.createElement('div');

        if(sender.getAdjacentAnchor(-1)){
            arrowLeft.innerHTML = '<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide-previous"></a>';
            arrowLeft.className = "controlbar-arrows";
        }
        if(sender.getAdjacentAnchor(1)){
            arrowRight.innerHTML = '<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide-next"></a>';
            arrowRight.className = "controlbar-arrows";
        }
        if (arrowLeft.innerHTML != "") {
            sender.createOverlay( { overlayId: arrowLeft, position: "bottom left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
            if (window.innerWidth >= 992) {
                sender.createOverlay( { overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
            };
        }
        if (arrowRight.innerHTML != "") {
            sender.createOverlay( { overlayId: arrowRight, position: "bottom right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
            if (window.innerWidth >= 992) {
                sender.createOverlay( { overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
            };
        }
    }
};

hs.Expander.prototype.onAfterClose = function(sender) {
    if (sender.custom && sender.custom.puUrl && sender.custom.puWidget) {
        executePartialUpdate(sender.custom.puUrl, sender.custom.puWidget);
    }
};

$( window ).on('resize', function() {
    if (window.innerWidth >= 992) {
        hs.marginBottom = 85;
        hs.marginLeft = 85;
        hs.marginRight = 85;
        hs.marginTop = 110;
        /*
         if (arrowLeft.innerHTML != "") {
         sender.createOverlay( { overlayId: arrowLeft, position: "middle left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
         }
         if (arrowRight.innerHTML != "") {
         sender.createOverlay( { overlayId: arrowRight, position: "middle right", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
         }
         */
    } else {
        hs.marginBottom = 110;
        hs.marginLeft = 30;
        hs.marginRight = 30;
        hs.marginTop = 30;
        /*
         if (arrowLeft.innerHTML != "") {
         sender.createOverlay( { overlayId: arrowLeft, position: "top left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
         }
         if (arrowRight.innerHTML != "") {
         sender.createOverlay( { overlayId: arrowRight, position: "top left", hideOnMouseOut: false, opacity: 1, width: 'auto', fade: 2, relativeTo: 'viewport' } );
         }
         */
    };
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/highslide-settings.js